import React from "react";
// react plugin used to create datetimepicker
import { Line } from "react-chartjs-2";

// reactstrap components
import {
Button,
Container,
Row,
Col,

  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  ListGroupItem,
  ListGroup,
  FormGroup,
  Input,
 
  
 

UncontrolledCarousel
} from "reactstrap";

import bigChartData from "variables/charts.js";


const carouselItems = [
{
src: require("assets/img/algo2.jpg"),

altText: "Slide 1",
caption: ""
},
{
src: require("assets/img/algo1.jpg"),
altText: "Slide 2",
caption: ""
},
{
src: require("assets/img/algo.png"),
altText: "Slide 3",
caption: ""
}
];

const carouselItems2 = [
{
src: require("assets/img/data.png"),

altText: "Slide 1",
caption: ""
},
{
src: require("assets/img/data1.png"),
altText: "Slide 2",
caption: ""
},
{
src: require("assets/img/algo3.png"),
altText: "Slide 3",
caption: ""
}
];

const carouselItems3 = [
{
src: require("assets/img/web.jpg"),

altText: "Slide 1",
caption: ""
},
{
src: require("assets/img/web1.jpg"),
altText: "Slide 2",
caption: ""
},
{
src: require("assets/img/web2.jpg"),
altText: "Slide 3",
caption: ""
}
];

class JavaScript extends React.Component {
constructor(props) {
super(props);
this.state = {
demoModal: false,
miniModal: false,
formModal: false
};
}
toggleModal = modalState => {
this.setState({
[modalState]: !this.state[modalState]
});
};


render() {
return (
<div className="section section-javascript" id="javascriptComponents">
 

  <div className="section">
    <Container>

      <Row className="justify-content-between align-items-center">
        <Col className="mb-5 mb-lg-0" lg="5">
        <h3 className="display-3 text-white">
          Hand-Picked Questions{" "}
          <span className="text-white">with complex analysis.</span>
        </h3>
        <p className="text-white mt-4">
          <h4>Coding Test of a company is solely targeted to eliminate the candidates.
            Thus, beat the competition with hand-picked 100s of the best coding interview questions to truly prepare you
            along with
            understanding how much memory an algorithm uses and how fast it runs.
            All of our analyses include a rigorous space-time and memory-time complexity analysis.</h4>
        </p>
        <Button className="mt-4" color="warning"
          href="https://demos.creative-tim.com/blk-design-system-react/#/documentation/alerts">
          See all components
        </Button>
        </Col>
        <Col lg="6">
        <UncontrolledCarousel items={carouselItems} indicators={false} autoPlay={true} />
        </Col>
      </Row>
    </Container>
  </div>
 

  <div className="section">
    <Container>

      <Row className="justify-content-between align-items-center">
        <Col lg="6">
        <UncontrolledCarousel items={carouselItems2} indicators={false} autoPlay={true} />
        </Col>

        <Col className="mb-5 mb-lg-0" lg="5">
        <h3 className="display-3 text-white">
          Data Structures {" "}
          <span className="text-white">and Algorithms.</span>
        </h3>
        <p className="" text-left>
          <h4>Algorithms and data structures go hand in hand; the solution to virtually any coding interview problem
            will require the implementation of some kind of abstract data type in order to access and manipulate
            information.
            Our video series on data structures is the ultimate crash course on this important topic. We cover
            fundamental concepts pertaining to memory, complexity analysis, and Big O notation, and then break down
            popular data structures to give you a detailed look at how these concepts are applied under the hood.
            Linked Lists and Binary Trees will never instill fear in your heart again.

          </h4>
        </p>
        <Button className="mt-4" color="warning"
          href="https://demos.creative-tim.com/blk-design-system-react/#/documentation/alerts">
          See all components
        </Button>
        </Col>

      </Row>
    </Container>
  </div>

  <div className="section">
    <Container>

      <Row className="justify-content-between align-items-center">
        <Col className="mb-5 mb-lg-0" lg="5">
        <h3 className="display-3 text-white">
          Full-Stack{" "}
          <span className="text-white">Development.</span>
        </h3>
        <p className="text-white mt-4">
          <h4>Go from no-code to an in-demand junior web or app developer.
            Start with the front-end by learning HTML, CSS, React, Flutter and JavaScript.
            Then, master the back-end and APIs to round out your full-stack skills.</h4>
        </p>
        <Button className="mt-4" color="warning"
          href="https://demos.creative-tim.com/blk-design-system-react/#/documentation/alerts">
          See all components
        </Button>
        </Col>
        <Col lg="6">
        <UncontrolledCarousel items={carouselItems3} indicators={false} autoPlay={true} />
        </Col>
      </Row>
    </Container>
  </div>

  <div className="wrapper">
          
            
      
          <section className="section section-lg">
            <section className="section">
             
              <Container>
                <Row className="row-grid justify-content-between">
                  <Col className="mt-lg-5" md="5">
                    <Row>
                      <Col className="px-2 py-2" lg="6" sm="12">
                        <Card className="card-stats">
                          <CardBody>
                            <Row>
                              <Col md="4" xs="5">
                                <div className="icon-big text-center icon-warning">
                                  <i className="tim-icons icon-zoom-split text-warning" />
                                </div>
                              </Col>
                              <Col md="8" xs="7">
                                <div className="numbers">
                                  <CardTitle tag="p">100+</CardTitle>
                                  <p />
                                  <p className="card-category">Questions</p>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="px-2 py-2" lg="6" sm="12">
                        <Card className="card-stats upper bg-default">
                          <CardBody>
                            <Row>
                              <Col md="4" xs="5">
                                <div className="icon-big text-center icon-warning">
                                  <i className="tim-icons icon-single-02 text-white" />
                                </div>
                              </Col>
                              <Col md="8" xs="7">
                                <div className="numbers">
                                  <CardTitle tag="p">1,000+</CardTitle>
                                  <p />
                                  <p className="card-category">Students</p>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="px-2 py-2" lg="6" sm="12">
                        <Card className="card-stats">
                          <CardBody>
                            <Row>
                              <Col md="4" xs="5">
                                <div className="icon-big text-center icon-warning">
                                  <i className="tim-icons icon-key-25 text-info" />
                                </div>
                              </Col>
                              <Col md="8" xs="7">
                                <div className="numbers">
                                  <CardTitle tag="p">50+</CardTitle>
                                  <p />
                                  <p className="card-category">Mentors</p>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="px-2 py-2" lg="6" sm="12">
                        <Card className="card-stats">
                          <CardBody>
                            <Row>
                              <Col md="4" xs="5">
                                <div className="icon-big text-center icon-warning">
                                  <i className="tim-icons icon-paper text-success" />
                                </div>
                              </Col>
                              <Col md="8" xs="7">
                                <div className="numbers">
                                  <CardTitle tag="p">1000 +</CardTitle>
                                  <p />
                                  <p className="card-category">Resources</p>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="6">
                    <div className="pl-md-5">
                      <h1>
                      Intellectual <br />
                      Community
                      </h1>
                      <p>
                        Join the Intellectual Community comprising of thousands of Students and
                        Upgrade your <b>career</b>

                      </p>
                      
                      <br />
                      <a
                        className="font-weight-bold text-info mt-5"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        Explore{" "}
                        <i className="tim-icons icon-minimal-right text-info" />
                      </a>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </section>
          
          <section className="section section-lg section-safe">
           
            <Container>
              <Row className="row-grid justify-content-between">
                
                <Col md="6">
                  <div className="px-md-5">
                    <hr className="line-success" />
                    <h3><b>Awesome Newsletters</b></h3>
                    <p>
                      Get daily Newletter and stay up to date with the latest wonders in the tech industry.</p>
                      <p>
                      Maybe you don’t have time to search all over the web for the most inventive and original stories, but you can definitely let someone else do the work for you. 
                      You can subscribe to our best free tech newsletters and you’re covered.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div className="icon icon-success mb-2">
                            <i className="tim-icons icon-vector" />
                          </div>
                          <div className="ml-3">
                            <h6>Daily Tech Updates.</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div className="icon icon-success mb-2">
                            <i className="tim-icons icon-tap-02" />
                          </div>
                          <div className="ml-3">
                            <h6>Informative and Entertaining.</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div className="icon icon-success mb-2">
                            <i className="tim-icons icon-single-02" />
                          </div>
                          <div className="ml-3">
                            <h6>Straight-laced commentary.</h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col md="5">
                  <img
                    alt="..."
                    className="img-fluid floating"
                    src={require("assets/img/job.png")}
                  />
                  <Card className="card-stats bg-danger">
                    <CardBody>
                      <div className="justify-content-center">
                        <div className="numbers">
                          <CardTitle tag="p">100%</CardTitle>
                          <p className="card-category text-white">Safe</p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <Card className="card-stats bg-info">
                    <CardBody>
                      <div className="justify-content-center">
                        <div className="numbers">
                          <CardTitle tag="p">Build</CardTitle>
                          <p className="card-category text-white">
                            your Resume
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <Card className="card-stats bg-default">
                    <CardBody>
                      <div className="justify-content-center">
                        <div className="numbers">
                          <CardTitle tag="p">Get </CardTitle>
                          <p className="card-category text-white">Industry Ready</p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <h1 className="text-center"><b>Your Best Benefits.</b></h1>
                  <Row className="row-grid justify-content-center">
                    <Col lg="3">
                      <div className="info">
                        <div className="icon icon-primary">
                          <i className="tim-icons icon-money-coins" />
                        </div>
                        <h4 className="info-title">Nominal Rates</h4>
                        <hr className="line-primary" />
                        <p>
                          Upskill your tech knowledge with the most nominal rates ever!
                        </p>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="info">
                        <div className="icon icon-warning">
                          <i className="tim-icons icon-chart-pie-36" />
                        </div>
                        <h4 className="info-title">High Incomes</h4>
                        <hr className="line-warning" />
                        <p>
                        Get the Necessary Education and Skills for Your Dream Job.
                        </p>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="info">
                        <div className="icon icon-success">
                          <i className="tim-icons icon-single-02" />
                        </div>
                        <h4 className="info-title">Placement Support</h4>
                        <hr className="line-success" />
                        <p>
                        Get 24/7 support from our global team of experts.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            
            <Col md="12">
              <Card className="card-chart card-plain">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="6">
                      <hr className="line-info" />
                      <h5 className="card-category">Your</h5>
                      <CardTitle tag="h2">Learning Curve</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={bigChartData.data}
                      options={bigChartData.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </section>
          <section className="section section-lg section-coins">
            
            <Container>
              <Row>
                <Col md="4">
                  <hr className="line-info" />
                  <h1>
                    Choose the Plan{" "}
                    <span className="text-info">that fits your needs</span>
                  </h1>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <Card className="card-coin card-plain">
                    <CardHeader>
                      <img
                        alt="..."
                        className="img-center img-fluid"
                        src={require("assets/img/bitcoin.png")}
                      />
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="text-center" md="12">
                          <h4 className="text-uppercase">Basic</h4>
                          <ListGroup>
                          <ListGroupItem> <b><h3>₹499 /PM</h3></b></ListGroupItem>
                          </ListGroup>
                          <hr className="line-primary" />
                        </Col>
                      </Row>
                      <Row>
                        <ListGroup>
                          
                          <ListGroupItem>Unlimited Access</ListGroupItem>

                          <ListGroupItem>Daily Newsletter</ListGroupItem>

                          <ListGroupItem>Limited Expert Support</ListGroupItem>


                  
                        </ListGroup>
                      </Row>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button className="btn-simple" color="primary">
                        Get plan
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-coin card-plain">
                    <CardHeader>
                      <img
                        alt="..."
                        className="img-center img-fluid"
                        src={require("assets/img/etherum.png")}
                      />
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="text-center" md="12">
                          <h4 className="text-uppercase">Lite</h4>
                          <ListGroup>
                          <ListGroupItem> <b><h3>₹999 /PM</h3></b></ListGroupItem>
                          </ListGroup>
                          <hr className="line-success" />
                        </Col>
                      </Row>
                      <Row>
                        <ListGroup>
                          <ListGroupItem>Unlimited Access</ListGroupItem>
                          
                          <ListGroupItem>Daily Newsletter</ListGroupItem>

                          <ListGroupItem>Real-world Projects</ListGroupItem>

                          <ListGroupItem>Limited Expert Support</ListGroupItem>



                        </ListGroup>
                      </Row>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button className="btn-simple" color="success">
                        Get plan
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-coin card-plain">
                    <CardHeader>
                      <img
                        alt="..."
                        className="img-center img-fluid"
                        src={require("assets/img/ripp.png")}
                      />
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="text-center" md="12">
                          <h4 className="text-uppercase">Pro</h4>
                          <ListGroup>
                          <ListGroupItem> <b><h3>₹1499 /PM</h3></b></ListGroupItem>
                          </ListGroup>
                          <hr className="line-info" />
                        </Col>
                      </Row>
                      <Row>
                        <ListGroup>
                          <ListGroupItem>Unlimited Access</ListGroupItem>

                          <ListGroupItem>Daily Newsletter</ListGroupItem>

                          <ListGroupItem>Real-world Projects</ListGroupItem>

                          <ListGroupItem>24/7 Expert Support</ListGroupItem>

                          <ListGroupItem>Complimentary Android App</ListGroupItem>

                        </ListGroup>
                      </Row>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button className="btn-simple" color="info">
                        Get plan
                      </Button>
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
          
        </div>


</div>

);
}
}

export default JavaScript;